import { mergeToNewObject } from '../../../util/helpers'
import { WALLET_BACKUP } from '../../../constants/actions'

export const backupProfile = (state = INITIAL_STATE, { type }) => {
  switch (type) {
    case WALLET_BACKUP.ON_COPY_TO_CLIPBOARD:
      return mergeToNewObject(state, { copySuccessMsg: 'wallet.backup.copy-success' })

    case WALLET_BACKUP.ON_RESET_STATE:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  copySuccessMsg: ''
}



// WEBPACK FOOTER //
// ./src/store/reducers/wallet/backup.js